// Credit is the only human-visible unit. Tokens NEVER surface in the UI.
//
// TWO formatters on purpose (Ali, 2026-08-06). USD is the ADMIN cost world only: what the app
// pays providers. A user must never see a dollar figure — they buy in Rial and spend credits,
// and a "≈ $" hint on their balance mixes the two money worlds the credit layer exists to keep
// apart. formatCredits = admin (with the peg hint); formatCreditsOnly = everything user-facing.
export function formatCredits(credits, peg = 0.01) {
  const c = Number(credits) || 0;
  const usd = c * (Number(peg) || 0.01);
  return `${c.toLocaleString()} credits (≈ $${usd.toFixed(2)})`;
}

// User-facing: the number only. The unit word comes from the locale (wallet.credits), so the
// caller passes it through t() — no currency, no peg, no conversion.
export function formatCreditsOnly(credits) {
  return (Number(credits) || 0).toLocaleString();
}
